/**
 * @fileoverview Agent definition for world-set-details-generator-v3.
 *
 * This agent generates complete details for a world set based on a
 * selected creative direction from the details ideation agent.
 *
 * @category world-building.sets.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-set-details-generator-v3',
  kind: 'primitive',
  name: 'World Set Details Generator',
  description: 'Generates complete details for a world set based on a selected creative direction.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.sets.details',
    usedBy: ['use-world-set-details-generator-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-set-details-ideation-v3',
      'world-set-snapshotter-v3',
    ],
  },
};
